import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
// helpers
import { checkHasAccessToAction } from "services/helpers";
// i18n
import { useTranslation } from "react-i18next";
// components
import BaseButton from "components/Button/BaseButton";
import TableAction from "components/Table/TableAction";
import BaseTd from "components/Table/BaseTd";
import ControlledCheckbox from "components/Checkbox/ControlledCheckbox";

import iconTrash from "assets/images/svg/trash-red.svg";

const Tbody = ({ data, isChecked, checkboxes, setCheckboxes, closeDeleteModal }) => {
  const { t } = useTranslation();

  let [_, setSearchParams] = useSearchParams();

  const hasAccessToEdit = checkHasAccessToAction("update-role");
  const hasAccessToDelete = checkHasAccessToAction("delete-role");

  const selectTableRow = (rowId) => {
    setCheckboxes({ ...checkboxes, [rowId]: !checkboxes[rowId] });
  };

  useEffect(() => {
    const objState = {};
    if (isChecked) {
      data.forEach((item) => {
        objState[item.id] = true;
      });
      setCheckboxes(objState);
    } else {
      const filterByTrue = Object.values(checkboxes).filter((el) => el);
      if (filterByTrue.length === data.length) setCheckboxes({});
    }
  }, [isChecked]);

  return (
    <>
      {data.map((item) => (
        <tr key={item.id} className="hover:bg-GreyLight dark:hover:bg-inputBgDark">
          <BaseTd>
            <div className="flex items-center gap-2">
              <ControlledCheckbox checked={checkboxes[item.id] || false} onChange={() => selectTableRow(item.id)} />
              <span>{item.name}</span>
            </div>
          </BaseTd>
          <BaseTd>{item.description}</BaseTd>
          <BaseTd>
            <div className="flex flex-wrap">
              {item.composites.length > 0
                ? item.composites.map((el) => (
                    <span
                      key={el.id}
                      className="p-1 my-1 mx-1 border border-[#D1D1D1] dark:border-[#2d2d2d] rounded bg-white text-[#535456] dark:text-white dark:bg-midBlack"
                    >
                      {el.name}
                    </span>
                  ))
                : "-"}
            </div>
          </BaseTd>
          <BaseTd>
            <div className="flex items-center gap-4 justify-end">
              {hasAccessToEdit && (
                <BaseButton
                  label={t("button.edit")}
                  className="btn-gray hover:bg-GreyInput dark:text-white dark:bg-midBlack dark:border-midBlack py-[6px] text-md h-[32px] text-[15px]"
                  onClick={() => setSearchParams({ row_id: item.id })}
                />
              )}
              {hasAccessToDelete && (
                <TableAction hasBackground parentClass="!h-[32px]">
                  <div
                    className="flex gap-2 p-1 rounded-[4px] hover:bg-GreyInput dark:hover:bg-midBlack"
                    onClick={() => closeDeleteModal(true, item.id)}
                  >
                    <img src={iconTrash} alt="delete" />
                    <p className="text-[#FF705D]">{t("button.delete")}</p>
                  </div>
                </TableAction>
              )}
            </div>
          </BaseTd>
        </tr>
      ))}
    </>
  );
};

export default Tbody;
